<template>
    <div class="small-12 medium-8 large-6 columns medium-push-2 large-push-3 mainPlot" style="position: relative;">
        <div style="position: absolute; top: 50%; left: 50%; height: width: 10%; width: 20%; margin-top: -15%; margin-left: -10%;">
            <overall-impact-graph :impact="overallImpact"></overall-impact-graph>
        </div>
        <div style="position: absolute; top: 50%; left: 50%; width: 20%; margin-top: 2%;margin-left: -10%; text-align: center; font-size: 1.5em; font-weight: bold; cursor: help;"
            v-tooltip.bottom="{content: '<strong>Nutriční stopa pokrmu</strong><br>nabývá hodnot od 1 do 5 (od nejmenšího dopadu po největší)'}"
        >
            {{ overallImpact }}
        </div>
        <chart :results="impacts"></chart>

        <img src="/themes/nutristopa/assets/img/climate.png"
             style="top: -17%; left: 43.5%;"
             class="mainPlot__image"
             v-tooltip.bottom="{content: 'Ukazuje pomocí barevné škály závažnost dopadu <strong>celkového množství skleníkových plynů způsobujících změnu klimatu</strong>, které byly vypuštěny do ovzduší v souvislosti s daným pokrmem.'}"
        >
        <img src="/themes/nutristopa/assets/img/acidification.png"
             style="top: 17%; left: 97%;"
             class="mainPlot__image"
             v-tooltip.left="{content: 'Ukazuje pomocí barevné škály závažnost dopadu <strong>celkového množství látek způsobujících okyselování půdy</strong>, které byly vypuštěny do prostředí v souvislosti s daným pokrmem.'}"
        >
        <img src="/themes/nutristopa/assets/img/euthropication.png"
             style="top: 90%; left: 84%;"
             class="mainPlot__image"
             v-tooltip.left="{content: 'Ukazuje pomocí barevné škály závažnost dopadu <strong>celkového množství látek způsobujících eutrofizaci vody (tj. nadbytek fosforu či dusíku)</strong>, které byly vypuštěny do prostředí v souvislosti s daným pokrmem.'}"
        >
        <img src="/themes/nutristopa/assets/img/occupation.png"
             style="top: 90%; left: 3%;"
             class="mainPlot__image"
             v-tooltip.right="{content: 'Ukazuje pomocí barevné škály závažnost dopadu <strong>celkové plochy zabrané půdy</strong>, která byla využita v souvislosti s daným pokrmem.'}"
        >
        <img src="/themes/nutristopa/assets/img/water.png"
             style="top: 17%; left: -8%;"
             class="mainPlot__image"
             v-tooltip.right="{content: 'Ukazuje pomocí barevné škály závažnost dopadu <strong>celkového množství využité vody</strong>, která byla použita v souvislosti s daným pokrmem.'}"
        >
    </div>
</template>

<script>
    import OverallImpactGraph from './OverallImpactGraph';
    import Chart from './Chart.js';

    export default {
        components: {
            OverallImpactGraph,
            Chart
        },

        props: [
            'overallImpact',
            'impacts'
        ]
    }
</script>

<style>
    .mainPlot__image {
        cursor: help;
    }
</style>